import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const ActionToolbar = ({ hasCalculationData = false }) => {
  const navigate = useNavigate();

  const handlePrintPreview = () => {
    const savedLoanData = localStorage.getItem('currentLoanCalculation');
    if (savedLoanData) {
      try {
        const parsedData = JSON.parse(savedLoanData);
        navigate('/print-preview-report', {
          state: { loanData: parsedData }
        });
      } catch (error) {
        console.error('Error parsing saved loan data:', error);
        navigate('/print-preview-report');
      }
    } else {
      navigate('/print-preview-report');
    }
  };

  if (!hasCalculationData) {
    return null;
  }

  return (
    <div className="flex items-center justify-between p-4 bg-surface border border-border rounded-lg mb-6 animate-slide-down">
      <div className="flex items-center space-x-2">
        <Icon name="FileText" size={20} className="text-primary" />
        <div>
          <h3 className="text-sm font-medium text-foreground">Amortization Schedule Ready</h3>
          <p className="text-xs text-text-secondary">Preview and print your calculation results</p>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        {/* Print Preview Button */}
        <Button
          variant="outline"
          size="sm"
          iconName="Eye"
          iconPosition="left"
          onClick={handlePrintPreview}
          className="hidden sm:flex"
        >
          Print Preview
        </Button>

        {/* Mobile */}
        <div className="flex sm:hidden">
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            onClick={handlePrintPreview}
          />
        </div>
      </div>
    </div>
  );
};

export default ActionToolbar;
